import api from './api';
import { supabase } from '../lib/supabase';
import type { AppLogRecord, LogsListResponse } from '../types/AppLog';

async function authHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = {};
  if (supabase) {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (session?.access_token) {
      headers.Authorization = `Bearer ${session.access_token}`;
    }
  }
  return headers;
}

export async function fetchLogs(params: Record<string, string | number | undefined>) {
  const headers = await authHeaders();
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== '')
  ) as Record<string, string>;
  return api.get<LogsListResponse>('/admin/logs', { params: clean, headers });
}

export async function fetchLogById(id: string) {
  const headers = await authHeaders();
  return api.get<AppLogRecord>(`/admin/logs/${id}`, { headers });
}
